import React from "react";
import brandLogo from "assets/images/auth/brand-logo.svg";
import brandMark from "assets/images/auth/brand-mark.svg";
import brandWordmark from "assets/images/auth/brand-wordmark.svg";
import invoiceIcon from "assets/images/auth/invoice-icon.svg";
import reminderIcon from "assets/images/auth/reminder-icon.svg";
import recoveryIcon from "assets/images/auth/recovery-icon.svg";

const features = [
  {
    icon: invoiceIcon,
    title: "Professional Invoices",
    copy: "Custom billing layouts",
  },
  {
    icon: reminderIcon,
    title: "Auto Reminders",
    copy: "Gentle smart reminders",
  },
  {
    icon: recoveryIcon,
    title: "Debt Recovery",
    copy: "Silver backup collection",
  },
];

function AuthBrandPanel() {
  return (
    <section className="auth-brand" aria-label="Invoice and Recover">
      <span className="auth-orb auth-orb--one" />
      <span className="auth-orb auth-orb--two" />
      <span className="auth-orb auth-orb--three" />
      <img
        className="auth-brand__logo"
        src={brandLogo}
        alt="Invoice & Recover"
      />
      <div className="auth-brand__mobile-logo">
        <img src={brandMark} alt="" />
        <img src={brandWordmark} alt="Invoice & Recover" />
      </div>
      <div className="auth-brand__message">
        <h1>Quote it. Invoice it. Get it back.</h1>
        <p>
          The simple all-in-one payment recovery pipeline trusted by over 12,000
          active trade and professional businesses
          <span className="desktop-only"> across Australia</span>.
        </p>
      </div>
      <div className="auth-brand__features">
        {features.map((feature) => (
          <div className="auth-feature" key={feature.title}>
            <span className="auth-feature__icon">
              <img src={feature.icon} alt="" />
            </span>
            <strong>{feature.title}</strong>
            <small>{feature.copy}</small>
          </div>
        ))}
      </div>
    </section>
  );
}
export default AuthBrandPanel;
